import type { Component } from "solid-js";
import { useI18n } from "~/i18n";
import { AgentLogo, type HandoffAgent, HandoffScene, type HandoffSession } from "./internal/HandoffScene";
import { SceneTabs } from "./internal/SceneTabs";

export type AgentHandoffData = HandoffSession & { agents: HandoffAgent[] };

/**
 * Handing a finished session to a coding agent, with a "Send to" picker across
 * the agents: a terminal launch for the CLI agents, a prompt to paste for the
 * chat ones. `onAgentChange` hears every switch, the picker's tour included.
 */
export const AgentHandoffMockup: Component<{
  data: AgentHandoffData;
  onAgentChange?: (agent: HandoffAgent) => void;
}> = (props) => {
  const { t } = useI18n();
  return (
    <SceneTabs
      items={props.data.agents}
      label={t("marketing.mock.handoff.picker")}
      onSelect={(agent) => props.onAgentChange?.(agent)}
      tab={(agent) => (
        <>
          <AgentLogo logo={agent.logo} class="size-4" />
          {agent.name}
        </>
      )}
    >
      {(agent) => (
        <HandoffScene
          agent={agent}
          session={props.data}
          label={t("marketing.mock.handoff.scene_alt", { agent: agent.name })}
        />
      )}
    </SceneTabs>
  );
};
